import apiClient from './client';

export type UserStatus = 'active' | 'blocked';

export interface User {
  urn: string;
  uuid: string;
  email: string;
  name: string;
  firstName?: string;
  lastName?: string;
  status?: UserStatus;
  privileges?: string[];
  profiles?: Array<{
    name: string;
    privileges: string[];
  }>;
  creationDate: string;
  modificationDate: string;
}

export interface CreateUserRequest {
  email: string;
  name: string;
  firstName?: string;
  lastName?: string;
  privileges?: string[];
}

export interface UpdateUserRequest {
  name?: string;
  firstName?: string;
  lastName?: string;
  privileges?: string[];
  [key: string]: unknown;
}

export interface UserEntitlement {
  urn: string;
  name: string;
  [key: string]: unknown;
}

export async function getUsers(): Promise<User[]> {
  const response = await apiClient.get('/oms/users');
  return response.data;
}

export async function getUser(urn: string): Promise<User> {
  const response = await apiClient.get(`/oms/users/${urn}`);
  return response.data;
}

export async function createUser(data: CreateUserRequest): Promise<User> {
  const response = await apiClient.post('/oms/users', data);
  return response.data;
}

export async function updateUser(urn: string, data: UpdateUserRequest): Promise<User> {
  const response = await apiClient.patch(`/oms/users/${urn}`, data);
  return response.data;
}

export async function updateUserStatus(urn: string, status: UserStatus): Promise<User> {
  const response = await apiClient.patch<User>(`/oms/users/${encodeURIComponent(urn)}/status`, { status });
  return response.data;
}

export async function getUserProducts(urn: string): Promise<unknown[]> {
  const response = await apiClient.get(`/oms/users/${urn}/products`);
  return response.data;
}

export async function getUserEntitlements(urn: string): Promise<UserEntitlement[]> {
  const response = await apiClient.get(`/oms/users/${urn}/entitlements`);
  return response.data;
}

export async function getUserByExternalId(externalUserId: string): Promise<User> {
  const response = await apiClient.get(`/oms/users/identity/${externalUserId}`);
  return response.data;
}
